import _objectWithoutProperties from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "className"];

var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { string } from "prop-types";
import Styled from "styled-components";
var RowStyle = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      background-color: ", ";\n      height: ", ";\n"])), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.height;
});
export var Row = function Row(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(RowStyle, _extends({
    className: "row ".concat(className)
  }, props), children);
};
Row.propTypes = {
  className: string,
  backgroundColor: string,
  height: string
};
Row.defaultProps = {
  className: "",
  backgroundColor: "",
  height: ""
};